export enum NuclideModelActivityUnit {
	MEGA_BEQUEREL = 'MEGA_BEQUEREL',
	GIGA_BEQUEREL = 'GIGA_BEQUEREL',
	KILO_BEQUEREL = 'KILO_BEQUEREL'
}
